<template>
      <table class="table table-borderless table-striped">
        <tbody>
        <tr>
          <td>E-Waybill</td>
          <td>{{ewaybill.ewb}}</td>
        </tr>
        <tr>
          <td>Consignor</td>
          <td>{{ewaybill.consignorGst}}<br />
            {{ewaybill.consignorAddr}}
          </td>
        </tr>
        <tr>
          <td>Consignee</td>
          <td>{{ewaybill.consigneeGst}}<br />
            {{ewaybill.consigneeAddr}}
          </td>
        </tr>
        <tr>
          <td>Invoice</td>
          <td>{{ewaybill.invoiceNo}}<br />
            {{ewaybill.invoiceDt | date}} <br />
            <i class="fal fa-rupee-sign"></i>    {{ewaybill.invoiceVal}} <br />
          </td>
        </tr>
        <tr>
          <td>Transporter</td>
          <td>{{ewaybill.transporterId}} <span v-if="ewaybill.awb">&ndash; {{ewaybill.awb}} &ndash; {{ewaybill.deliveryStatus}}</span></td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <span v-if="ewaybill.cancelled === true">Cancelled <i class="fa fa-times-square text-danger"></i> </span>
            <span v-if="ewaybill.validTill !== null && !expired">Active <i class="fa fa-check-circle text-success"></i> </span>
            <span v-if="ewaybill.validTill === null">No Part-B <i class="fa fa-check-circle text-danger"></i> </span>
            <span v-if="expired">Expired <i class="fa fa-times-circle text-danger"></i> </span>
          </td>
        </tr>
        </tbody>
      </table>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BasicEWBDetails',
  props: ['ewaybill'],
  data () {
    return {}
  },
  computed: {
    expired: function () {
      if (this.ewaybill.validTill == null) return false
      if (moment(this.ewaybill.validTill).isBefore(moment())) return true
      return false
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/BasicEWBDetails.vue